export default __webpack_public_path__ + "static/media/plan-active.bbdb6e2b.svg";